import classes from "./Wrap.module.css";

const Wrap = (props) => {
  return <div className={classes.wrap}>{props.children}</div>;
};

export default Wrap;
